<template>
    <el-dialog
        title="选择部门"
        :visible.sync="departmentShow"
        :show-close="false"
        :close-on-click-modal="false"
        width="600px">
        <el-row>
            <el-col :span="24" style="border-right: 1px solid rgba(216, 220, 225, 0.39);">
                <el-card class="box-card" :body-style="{ height: '460px', overflow: 'auto' }" shadow="never">
                <div style="display: none;">
                    <el-input
                    class="filter-input"
                    placeholder="搜索部门"
                    prefix-icon="el-icon-search"
                    v-model="filterTexts"
                    size="small"
                    clearable
                    >
                    </el-input>
                </div>
                <el-tree
                    ref="departmentData"
                    id="fixtree"
                    :data="departmentData"
                    node-key="value"
                    show-checkbox
                    :props="departmentProps"
                    @check="getCurrentNode"
                    :default-expanded-keys="departs"
                    :default-checked-keys="departs"
                    :filter-node-method="filterDepart"
                >
                <span class="custom-tree-node" slot-scope="{ node, data }">
                    <span>
                        <img src="../../src/assets/images/zuzhi.png" style="width:14px;height:14px;" alt="">
                        <span v-if="data.is_show === true" style="color: #9D9D9D;">{{ data.label }}</span>
                        <span v-if="data.is_show === false">{{ data.label }}</span>
                    </span>
                    </span>
                </el-tree>
                </el-card>
            </el-col>
        </el-row>
        <span slot="footer" class="dialog-footer">
            <el-button type="info" plain @click="$emit('check-depart', checkedDepartment)">取消</el-button>
            <el-button style="width: 72px;" type="primary" :disabled="disabled2"  @click="$emit('check-depart', checkedDepartment)">确定</el-button>
        </span>
    </el-dialog>
</template>

<script>
    export default {
        props: {
            departmentShow: {
                type: Boolean,
                required: true,
                default: false
            },
            department: {
                type: Array,
                required: true
            },
            checkeds: {
                type: Array,
                required: false
            }
        },
        data() {
            return {
                departmentProps: {
                    children: 'child',
                    label: 'label',
                    value: 'value',
                    disabled: 'is_show'
                },
                depapart_id: [],
                checkedDimission: [],
                checkedDepartment: [],
                departmentData: [],
                disabled2: true,
                filterTexts: '',
                departs: [],
                dehfe: 1
            }
        },
        watch: {
            departmentShow: function(newVal, oldVal) {
                // if (!newVal) {
                //     this.departmentData = []
                // }
            },
            filterTexts(val) {
                if (val) {
                    this.$refs.departmentData.filter(val)
                }
            },
            checkedDepartment(val) {
                if (val.length > 0) {
                    this.disabled2 = false
                } else {
                    this.disabled2 = true
                }
            }
        },
        mounted() {
            if (this.checkeds || this.checkeds.length > 0) {
                this.checkedDepartment = this.checkeds
                this.checkeds.forEach(k => {
                    this.departs.push(k.value)
                })
                this.checkedDepartment.forEach(k => {
                    k.is_show = true
                })
            } else {
                this.departs = []
            }
            // this.getDepartment()
            this.departmentData = this.department
        },
        methods: {
            getCurrentNode(data) {
                if (data) {
                    const node = this.$refs.departmentData.getNode(data)
                    const checkedDepartment = this.checkedDepartment
                    if (node.checked === true) {
                        checkedDepartment.push({
                            label: node.data.label,
                            value: node.data.value
                        })
                        this.childJin(data, checkedDepartment)
                    } else {
                        checkedDepartment.forEach((k, i) => {
                            if (node.data.value === k.value) {
                                checkedDepartment.splice(i, 1)
                            }
                        })
                        this.childYong(data)
                    }
                    this.childNodes(node)
                }
            },
            childNodes(node) {
                const len = node.childNodes.length
                for (let i = 0; i < len; i++) {
                    node.childNodes[i].checked = node.checked
                    this.childNodes(node.childNodes[i])
                }
            },
            // 选中禁用子节点
            childJin(data) {
                const a = data.child.length
                for (let i = 0; i < a; i++) {
                    data.child[i].is_show = true
                    this.checkedDepartment.push({
                        label: data.child[i].label,
                        value: data.child[i].value
                    })
                    this.childJin(data.child[i])
                }
            },
             // 解除选中禁用子节点
            childYong(data) {
                const a = data.child.length
                for (let i = 0; i < a; i++) {
                    data.child[i].is_show = false
                    for (let j = 0; j < this.checkedDepartment.length; j++) {
                        if (this.checkedDepartment[j].value === data.child[i].value) {
                            this.checkedDepartment.splice(j, 1)
                            continue
                        }
                    }
                    this.childYong(data.child[i])
                }
            },
            // tree过滤
            filterDepart(value, data) {
                if (!value) return true
                return data.label.indexOf(value) !== -1
            }
        }
    }
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__body {
    padding: 0;
    box-shadow: none;
}
.filter-input {
  margin-bottom: 8px;
  line-height: 34px;
}
</style>
